module.exports = __webpack_public_path__ + "fonts/coin-stack_svgrepo.com.svg";